<script setup>
defineOptions({ name: 'DsCard' });

defineProps({
  padded: { type: Boolean, default: true }
});
</script>

<template>
  <div :class="['ds-card', { 'is-padded': padded }]">
    <slot />
  </div>
</template>
